import request from '@/config/axios'

export interface LiveCategoryVO {
  id?: number
  name: string
  code?: string
  icon?: string
  sort?: number
  status?: number
}

export const pageCategory = (params: any) => request.get({ url: '/live/category/page', params })
export const getCategory = (id: number) =>
  request.get({ url: '/live/category/get', params: { id } })
export const createCategory = (data: LiveCategoryVO) =>
  request.post({ url: '/live/category/create', data })
export const updateCategory = (data: LiveCategoryVO) =>
  request.put({ url: '/live/category/update', data })
export const deleteCategory = (id: number) =>
  request.delete({ url: '/live/category/delete', params: { id } })
export const listEnabledCategory = () => request.get({ url: '/live/category/list-enabled' })
